import { createSlice } from '@reduxjs/toolkit';
import { resetErrorSlice, resetStore } from '../../Actions';
// import { resetErrorSlice, resetStore } from '../../Actions';

const initialState = {
  errorData: {
    open: false,
    message: null
  }
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setApiError(state, action) {
      state.errorData.open = true;
      state.errorData.message = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
    builder.addCase(resetErrorSlice, () => initialState); // clear error slice
  }
});

export const { setApiError } = errorSlice.actions;
export default errorSlice.reducer;
